module.exports = __webpack_public_path__ + "static/joseph-23de2f90904422185da71ca6f9ee22a3.png";